import { reactive } from "vue";
import { TaikyoApi } from "./taikyo/TaikyoApi";
import { NyukyoInfoApi } from "./nyukyoInfo/NyukyoInfoApi";
import { TopApi } from "./top/TopApi";
import { PasswordApi } from "./password/PasswordApi";
import { ShomeiApi } from "./shomei/ShomeiApi";
import { AuthApi } from "./auth/AuthApi";
import { KaiyakuApi } from "./kaiyaku/KaiyakuApi";
import { SeikyuInfoApi } from "./seikyuInfo/SeikyuInfoApi";
import { PersonalApi } from "./personal";
import { KeiyakuApi } from "./keiyaku/KeiyakuApi";
import { InformationApi } from "./information/InformationApi";
import { CommonApi } from "./Common/CommonApi";
import { TermsOfUseApi } from "./termsOfUse/TermsOfUseApi";
import { LatestApi } from "./latest/LatestApi";
import { TaikyoNotificationApi } from "./taikyoNotification";
/** APIのファサード */
class Api {
    taikyo = new TaikyoApi();
    nyukyoInfos = new NyukyoInfoApi();
    top = new TopApi();
    password = new PasswordApi();
    shomei = new ShomeiApi();
    auth = new AuthApi();
    kaiyaku = new KaiyakuApi();
    taikyoNotification = new TaikyoNotificationApi();
    seikyuInfo = new SeikyuInfoApi();
    personal = new PersonalApi();
    keiyaku = new KeiyakuApi();
    information = new InformationApi();
    common = new CommonApi();
    termsOfUse = new TermsOfUseApi();
    latest = new LatestApi();
}
export const api = reactive(new Api());
